/* eslint-disable jsdoc/require-jsdoc */
import { baseApi } from '@/services/BaseApi';
import config from '@/app/editor/config';
import type { PresetOptionsRequest, PresetOptionType } from '@modules/global-style/types';
/**
 *
 */
export const globalStyleService = {
  getPresets: () => {
    return baseApi.get('/api/global-style/presets');
  },

  getPages: (params?: {}) => {
    return baseApi.get('/api/global-style/pages', { params: params });
  },

  createNewPreset: (params?: {}) => {
    let path = '/api/global-style/presets';

    if (config.isDev()) {
      path = '/api/global-style/presets/create-new-preset';
    }

    return baseApi.post(path, params);
  },

  duplicatePreset: (presetId: number) => {
    let path = `/api/global-style/presets/${presetId}/duplicate`;

    if (config.isDev()) {
      path = '/api/global-style/presets/duplicate.html';
      return baseApi.get(path);
    }

    return baseApi.post(path);
  },

  publishPreset: (presetId: number, content: string) => {
    let path = `/api/global-style/presets/${presetId}/publish`;

    if (config.isDev()) {
      path = '/api/global-style/presets/publish.html';
      return baseApi.post(path, { content: content });
    }

    return baseApi.post(path, { content: content });
  },

  deletePreset: (presetId: number) => {
    let path = `/api/global-style/presets/${presetId}`;

    if (config.isDev()) {
      path = '/api/global-style/presets/delete.html';
      return baseApi.get(path);
    }

    return baseApi.delete(path);
  },

  updatePreset: (presetId: number, params?: {}) => {
    let path = `/api/global-style/presets/${presetId}/save`;

    if (config.isDev()) {
      path = '/api/global-style/presets/update.html';
      return baseApi.get(path, params);
    }

    return baseApi.post(path, params);
  },

  crawlHtmlSourceLiveTheme: () => {
    return baseApi.get('/api/global-style/crawl-live-theme');
  },

  getCurrentPresetPage: (pageId: number) => {
    let path = `/api/global-style/pages/${pageId}/current-preset`;

    if (config.isDev()) {
      path = '/api/global-style/pages/get-current-preset';
    }

    return baseApi.get(path);
  },

  applyPresetToPage: (params: { pageId: number; presetId: number }) => {
    let path = `/api/global-style/presets/${params.presetId}/pages/${params.pageId}/link`;

    if (config.isDev()) {
      path = '/api/global-style/presets/link-preset-to-page';
    }

    return baseApi.post(path);
  },

  unlinkPresetFromPage: (params: { pageId: number; presetId: number }) => {
    const path = `/api/global-style/presets/${params.presetId}/pages/${params.pageId}/unlink`;

    return baseApi.post(path);
  },

  savePresetOptions: (params: { id: number; type?: PresetOptionType }, data: PresetOptionsRequest) => {
    let path = `/api/global-style/presets/${params.id}/preset-options/save`;

    if (config.isDev()) {
      path = '/api/global-style/presets/save-preset-options';
    }
    // eslint-disable-next-line camelcase,@typescript-eslint/camelcase
    return baseApi.post(path, { preset_options: data.preset_options, css_str: data.css_str });
  },
};
